<template>
  <el-col :span="24" class="header">
    <el-col :span="20" class="logo logo-width"></el-col>
    <el-col :span="4" class="userinfo">
      <span class="el-dropdown-link">
        <a v-if="multiLanguage" href="#" @click="setLang()">{{
          langToChange
        }}</a>
        <a @click="logout">{{ $t('logout') }}</a>
      </span>
    </el-col>
  </el-col>
</template>
<script>
export default {
  data() {
    return {
      multiLanguage: false
    }
  },
  computed: {
    langToChange() {
      return this.$i18n.locale === 'pl' ? 'en' : 'pl'
    }
  },
  methods: {
    logout: function () {
      this.$confirm(this.$i18n.t('areYouSure'), this.$i18n.t('logout'), {
        //type: 'warning'
      })
        .then(() => {
          window.localStorage.removeItem('token')
          this.$router.push('/login')
        })
        .catch(() => {})
    },
    setLang() {
      localStorage.lang = this.langToChange
      this.$i18n.locale = this.langToChange
      //				location.reload()
      this.$router.go(this.$router.currentRoute)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;

  .header {
    height: 60px;
    line-height: 60px;
    color: #333333;

    .userinfo {
      text-align: right;
      padding-right: 35px;
      float: right;

      .el-dropdown-link {
        cursor: pointer;
        color: #999c9e;
        font-size: 14px;
        font-weight: 700;
      }
    }

    .logo {
      background: #2f4050;
      color: #ffffff;
      height: 60px;
      padding: 0 20px;
    }

    .logo-width {
      width: 219px;
    }

    .logo-collapse-width {
      width: 60px;
    }
  }
}
</style>
